declare global {
  interface Window {
    // Undefined until Clarity is initialized (production only).
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[][] }
  }
}

const CLARITY_ID = 'v0z7oknpg1'
const isProduction = import.meta.env.PROD

let isInitialized = false

export function initializeClarity(): void {
  if (!isProduction || isInitialized) return

  // Queue calls until the script loads; Clarity drains `clarity.q` on start.
  if (!window.clarity) {
    const queue: unknown[][] = []
    window.clarity = Object.assign(
      (...args: unknown[]) => {
        queue.push(args)
      },
      { q: queue },
    )
  }

  // Load the Clarity script
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  isInitialized = true
}

/**
 * Send a custom event to Clarity. Appears on the recording timeline and can be
 * used to filter session recordings. No-op when Clarity is not loaded (dev).
 */
export function trackClarityEvent(name: string): void {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') {
    return
  }
  try {
    window.clarity('event', name)
  } catch {
    // ignore — Clarity must never break the app
  }
}

/**
 * Set a custom tag (dimension) on the current Clarity session. Enables
 * segmenting and filtering recordings by funnel step, error state, etc.
 */
export function setClarityTag(key: string, value: string | string[]): void {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') {
    return
  }
  try {
    window.clarity('set', key, value)
  } catch {
    // ignore — Clarity must never break the app
  }
}
